var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panoramas"},[_c('div',{staticClass:"photosphere",attrs:{"id":"viewer"}}),_c('div',{staticClass:"buttons"},[_c('button',{on:{"click":function($event){return _vm.previousPhoto()}}},[_vm._v("Previous")]),_c('button',{on:{"click":function($event){return _vm.nextPhoto()}}},[_vm._v("Next")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }